/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconChevronLeft/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconChevronLeft({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconChevronLeft",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "#353535",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconChevronLeft.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z1Ewujj': alignSelf,'--mt-2-Z1Ewujj': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1Ewujj': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1Ewujj': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1Ewujj': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1Ewujj': opacity,'--w-10-Z1Ewujj': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1Ewujj': typeof height === 'number' ? `${height}px` : height,'--f-12-Z1Ewujj': fill,'--a-7-Z1Ewujj': isAnimated ? animation : "none",'--sd-8-Z1Ewujj': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1Ewujj': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconChevronLeft.SvgPath"
  data-view-path={viewPath}
 d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z"
 className="views-block"
/>
</svg>
{children}
</React.Fragment>)
}